var api = {
    inputClassName: 'form-control',
    listClassName: 'edit-list list-group'
};


module.exports = api;


/** WEBPACK FOOTER **
 ** ./src/Constants.js
 **/